import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NotificationSearchFilter } from 'src/app/searchFilters/notificationSearchFilter';
import { NotificationService } from 'src/app/services/notification.service';
@Component({
  selector: 'app-notification-popup',
  templateUrl: './notification-popup.component.html',
  styleUrls: ['./notification-popup.component.css']
})
export class NotificatoinPopupComponent implements OnInit {


  displayedColumns: string[] = [''];
  sortColumns: string[] = ['notificationText'];
  sortDisabledColumn: string[] = ['Action'];

  data: any[] = [];
  itemPerPage: number = 10;
  endIndex: number = this.itemPerPage;
  currentIndex: number = 1;
  sortby: string = '';
  order: string = '';
  notificationFilter = new NotificationSearchFilter();
  notificationCount: number;


  constructor(
    private notificationService: NotificationService,
    private toastr: ToastrService) { }

    ngOnInit(): void {
      this.notificationService.notificationObservable.subscribe(value => {
        this.notificationFilter.isRead = false;
        this.notificationService.getNotificationList(this.notificationFilter).subscribe(data => {
          if (data["result"]) {
            this.notificationCount = data["result"].length;
            this.data = data["result"];
            this.data = this.data.slice(0, 5);
          }
        }, err => {
          console.log(err);
          this.toastr.error(err["message"], "error");
        });
      });
      //this.getNotifications();
    }
    getNotifications() {
      this.notificationFilter.isRead = false;
      this.notificationService.getNotification(this.currentIndex, this.itemPerPage, this.order, this.sortby, this.notificationFilter).subscribe(data => {
  
      }, err => {
        console.log(err);
        this.toastr.error(err["message"], "error");
      });
    }

}
